import { Alert, Button } from 'antd'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useOnboarding } from '../../contexts/OnboardingContext'
import { OnboardingSkeleton } from '../OnboardingSkeleton'
import { Template } from '../../template'

export function OnboardingGate ({ children }: { children: ReactNode }): React.ReactElement {
  const { state, isLoading, error, reload } = useOnboarding()
  const location = useLocation()
  if (location.pathname === '/onboarding') return <>{children}</>
  if (isLoading) return <Template pageTitle='Configuração inicial' isSetup><OnboardingSkeleton /></Template>
  if (error) return <Template pageTitle='Configuração inicial' isSetup><Alert type='error' showIcon title={error} action={<Button onClick={() => { void reload() }}>Tentar novamente</Button>} /></Template>
  if (state?.step) return <Navigate replace to='/onboarding' state={{ from: location.pathname + location.search + location.hash }} />
  return <>{children}</>
}
